"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GalileanWaystation = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var Resources_1 = require("../../Resources");
var Card_1 = require("../Card");
var CardRenderer_1 = require("../render/CardRenderer");
var GalileanWaystation = (function (_super) {
    __extends(GalileanWaystation, _super);
    function GalileanWaystation() {
        return _super.call(this, {
            cost: 15,
            tags: [Tags_1.Tags.SPACE],
            name: CardName_1.CardName.GALILEAN_WAYSTATION,
            cardType: CardType_1.CardType.AUTOMATED,
            metadata: {
                description: 'Increase your M€ production 1 step for every Jovian tag in play.',
                cardNumber: 'C13',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.megacredits(1).slash().jovian().played.any; });
                }),
                victoryPoints: 1,
            },
        }) || this;
    }
    GalileanWaystation.prototype.play = function (player) {
        var amount = player.game.getPlayers()
            .map(function (aplayer) { return aplayer.getTagCount(Tags_1.Tags.JOVIAN, false, player.id === aplayer.id); })
            .reduce(function (a, c) { return a + c; }, 0);
        player.addProduction(Resources_1.Resources.MEGACREDITS, amount, { log: true });
        return undefined;
    };
    GalileanWaystation.prototype.getVictoryPoints = function () {
        return 1;
    };
    return GalileanWaystation;
}(Card_1.Card));
exports.GalileanWaystation = GalileanWaystation;
//# sourceMappingURL=GalileanWaystation.js.map